import { sortByDate } from "@/functions/sortByDate";
import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import simplePages from "@/../.sourceflow/simple_pages.json";
import careerAdvice from "@/../.sourceflow/career_advice.json";

export const useBlogs = ({ source, limit = null } = {}) => {
  const collection = sortByDate(useSourceFlowCollection(source == "simple_pages" || source =="industry_insights" ? simplePages : careerAdvice), "publish_date");

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useBlogs;
